export default __webpack_public_path__ + "static/media/6.cac5cdc5.jpeg";